// This file must be present so auto.require.config.js will find and pre-require this module
define('model/person.model',['require','exports','module','fukit/fukit','./association.model','datakit/datakit'],function(require, exports, module) {
  //prettier-ignore
  var FuKit             = require('fukit/fukit'),
      AssociationsModel = require('./association.model'),
      Datakit           = require('datakit/datakit');

  var PersonModel = FuKit.PersonModel.extend({
    defaults: {
      affiliations: [],
    },

    childModels: {
      affiliations: AssociationsModel,
    },

    relationships: {
      contact: {
        foreignKey: 'contactId',
        fetchMode: Datakit.ResourceRelationship.EAGER_FETCH,
        resourceClass: 'ContactModel',
        type: 'belongsTo',
      },
    },
  });

  module.exports = PersonModel;
});

